import { Card as CardAntd, Typography as TypographyAntd } from 'antd';
import styled from 'styled-components';

export const LabelCheckbox = styled.span`
  color: #4f4f4f !important;
`;

export const TitleSubGroup = styled.span`
  font-weight: 600;
  color: #4f4f4f;
`;

export const SubTitleCard = styled(TypographyAntd.Paragraph)`
  display: block;
  font-weight: 500;
  font-size: 14px;
`;

export const Card = styled(CardAntd)`
  margin: 1px !important;
  margin-bottom: 25px !important;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgb(0 0 0 / 25%);
  padding: 10px 16px;

  .ant-card-body {
    padding: 10px !important;

    .col-card {
      margin-bottom: 20px;
    }

    .col-card:last-child {
      margin-bottom: 0px !important;
    }
  }
`;
